var _excluded = ["context", "element", "index", "disabled", "focusable"],
  _excluded2 = ["element"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useCallback, useMemo, useState } from 'react';
import { useSafeLayoutEffect, useForceUpdate } from '../../hooks';
export function useDescendant(props) {
  var {
      context,
      element,
      index: indexProp,
      disabled,
      focusable
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var forceUpdate = useForceUpdate();
  var {
    register,
    unregister,
    descendants
  } = context;
  useSafeLayoutEffect(() => {
    if (!element) {
      forceUpdate();
    }

    /**
     * Don't register this descendant if it is disabled and not focusable
     */
    if (disabled && !focusable) return undefined;

    /**
     * else, register the descendant
     */
    register(_objectSpread({
      element,
      disabled,
      focusable
    }, rest));

    /**
     * when it unmounts, unregister the descendant
     */
    return () => {
      if (element) {
        unregister(element);
      }
    };
    // eslint-disable-next-line
  }, [element, disabled, focusable, ...Object.values(rest)]);
  return indexProp !== null && indexProp !== void 0 ? indexProp : descendants.findIndex(descendant => descendant.element === element);
}
export function useDescendants() {
  var [descendants, setDescendants] = useState([]);
  var register = useCallback(_ref => {
    var {
        element
      } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded2);
    if (!element) return;
    setDescendants(prevDescendants => {
      if (prevDescendants.find(item => item.element === element) == null) {
        var index = prevDescendants.findIndex(item => {
          if (!item.element || !element) return false;
          return Boolean(item.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING);
        });
        var newItem = _objectSpread({
          element
        }, rest);
        if (index === -1) {
          return [...prevDescendants, newItem];
        }
        return [...prevDescendants.slice(0, index), newItem, ...prevDescendants.slice(index)];
      }
      return prevDescendants;
    });
  }, []);
  var unregister = useCallback(element => {
    if (!element) return;
    setDescendants(descendants => descendants.filter(descendant => element !== descendant.element));
  }, []);
  return useMemo(() => ({
    descendants,
    register,
    unregister
  }), [descendants, register, unregister]);
}